module.exports = __webpack_public_path__ + "img/headset-one.cd08d7cb.svg";